import React from "react";
import {makeStyles, Table, TableBody, TableCell, TableHead, TableRow} from "@material-ui/core";
import Tr from "translations/Translations";
import ViewMode from "../constants/OfferEvaluationViewMode";
import OffersEvaluationRow from "./OffersEvaluationRow";
import PropTypes from "prop-types";
import BoldTypography from "../../../../../../../../components/BoldTypography";

const useStyles = makeStyles(theme => ({
    table: {
        border: `solid 3px ${theme.palette.background.paper}`,
        "& .MuiTableCell-root": {
            border: `solid 1px ${theme.palette.border.dark}`,
            padding: theme.spacing()
        }
    },
    headRow: {
        "&>.MuiTableCell-head": {
            textAlign: "center",
            borderBottom: `solid 2px ${theme.palette.primary.main}`
        }
    },
    critColumn: {},
    weightColumn: {
        width: 40
    },
    valueColumn: {
        width: '15%'
    },
    scoreColumn: {
        width: 100
    },
    scoreTotalColumn: {
        width: 50
    },
    statusColumn: {
        width: 170
    },

}));

function OffersEvaluationTable(
    {
        editable,
        offerEvaluationItem,
        updateScore,
        updateStatus
    }) {

    const classes = useStyles();

    const mode = offerEvaluationItem?.mode;

    const onUpdateScore = async (score, criterion, row) => {
        await updateScore(score, criterion, row, offerEvaluationItem, mode);
    }

    const onUpdateStatus = async (status, row) => {
        await updateStatus(status, row, offerEvaluationItem, mode);
    }

    return (<Table className={classes.table}>
        <TableHead>
            <TableRow className={classes.headRow}>
                <TableCell className={classes.partColumn}>{Tr(mode === ViewMode.SUPPLIER ? "part" : "offer")}</TableCell>
                <TableCell className={classes.critColumn}>{Tr("criteria")}</TableCell>
                <TableCell className={classes.weightColumn}>{Tr("weight")}</TableCell>
                <TableCell className={classes.valueColumn}>{Tr("value")}</TableCell>
                <TableCell className={classes.scoreColumn}>{Tr("score")}</TableCell>
                <TableCell className={classes.scoreTotalColumn}>{Tr("score_total")}</TableCell>
                <TableCell className={classes.statusColumn}>{Tr("status")}</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {
                offerEvaluationItem.offerEvaluations.length ?
                    offerEvaluationItem.offerEvaluations.map((x, index) =>
                        <OffersEvaluationRow
                            key={x.identity}
                            offerEvaluationRow={x}
                            editable={!!editable && !!x.editable}
                            mode={mode}
                            rowNumber={index + 1}
                            updateScore={onUpdateScore}
                            updateStatus={onUpdateStatus}
                        />)
                    :
                    <TableRow>
                        <TableCell colSpan={7}>
                            <BoldTypography align='center'>{Tr('no_options')}</BoldTypography>
                        </TableCell>
                    </TableRow>
            }
        </TableBody>
    </Table>)
}

OffersEvaluationTable.propTypes = {
    editable: PropTypes.bool.isRequired,
    offerEvaluationItem: PropTypes.object.isRequired,
    updateScore: PropTypes.func.isRequired,
    updateStatus: PropTypes.func.isRequired
}

export default OffersEvaluationTable;

